/**
 * The support grant a staff session opened a company under, kept for this tab so the in-company
 * banner can say whether the view is read-only and how long is left (round 2, support R2-M4). The
 * API holds the grant and enforces it; this is only what the banner reads. Never anything secret.
 */
export interface RememberedGrant {
  tenant: string;
  company: string;
  mode: 'read' | 'write';
  expiresAt: string;
}

const KEY = 'paige.supportGrant';

export function rememberGrant(g: RememberedGrant): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(g));
  } catch {
    // A private window without storage still works; the banner falls back to its plain words.
  }
}

export function grantFor(tenant: string, now: number = Date.now()): RememberedGrant | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    const g = raw ? (JSON.parse(raw) as RememberedGrant) : null;
    return g && g.tenant === tenant && Date.parse(g.expiresAt) > now ? g : null;
  } catch {
    return null;
  }
}

export function forgetGrant(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to forget.
  }
}
